import { createAction } from 'redux-actions'

const prefix = 'Navigation:'
export const SET_PAGE_TITLE = `${prefix} Set page title.`

const setPageTitle = createAction(SET_PAGE_TITLE)

export const actionCreators = {
  setPageTitle,
}
